import Vue from "vue";
import VueRouter from "vue-router";

import Home from "@/components/home/Home";
import AdminPages from "@/components/admin/AdminPages";
import ArticlesByCategory from "@/components/article/ArticlesByCategory";
import ArticleById from "@/components/article/ArticleById";
import Auth from "@/components/auth/Auth";

import GlobusConvocacaoPrincipal from "../components/treinamento/GlobusConvocacaoPrincipal";
import InformaticaPrincipal from "../components/informatica/InformaticaPrincipal";
import SinistroPrincipal from "../components/sinistro/SinistroPrincipal";
import InfoPrincipal from "../components/informativo/InfoPrincipal";
import SacPrincipal from "../components/sac_solicitacao/SacPrincipal";
import ManPreventivaLancamento from "../components/man_preventiva/ManPreventivaLancamento";
import ManutencaoRfiLancamento from "../components/man_rfi/ManutencaoRfiPrincipal";
import ManutencaoLavadorPrincipal from "../components/man_lavador/ManutencaoLavadorPrincipal";
import SolturaDeFrotaPrincipal from "../components/operacao_frota/SolturaDeFrotaPrincipal";
import TrafegoMonitoramento from "../components/trafego/TrafegoMonitoramento";
import DashboardOperacional from "../components/trafego/DashboardOperacional";
import LinhaPrincipal from "../components/pla_linha/LinhaPrincipal";
import EscalaModeloMenu from "../components/pla_linha/EscalaModeloMenu";
import PontoEletronicoPrincipal from "../components/flp_pontoeletronico/PontoEletronicoPrincipal";
import PonEletronicoPrincipal from "../components/ml18_frq_pontoeletronico/PonEletronicoPrincipal";
import CorretivaPrincipal from "../components/man_corretiva/CorretivaPrincipal";
import FuncionarioPrincipal from "../components/folhapagamento/FuncionarioPrincipal";
import KontrowPrincipal from "../components/kontrow/KontrowPrincipal"; // apresentou problema quando tentei usar a pasta integracoes/kontrow
import RequisicaoPrincipal from "../components/estoque/RequisicaoPrincipal"; // apresentou problema quando tentei usar a pasta integracoes/kontrow
import PlantaoMenu from "../components/plantao/PlantaoMenu"; // apresentou problema quando tentei usar a pasta integracoes/kontrow
import AbastecimentoPrincipal from "../components/abastecimento/AbastecimentoPrincipal"; // 10/03/2024 as 11:25h
import FrotaPrincipal from "../components/despachante/FrotaPrincipal"; // 10/03/2024 as 11:25h
import PneuPrincipal from "../components/pneu/PneuPrincipal"; // 10/03/2024 as 11:25h
import PneuPrincipalLançamentos from "../components/pneu/PneuPrincipalLançamentos"; // 10/03/2024 as 11:25h
import JuridicoPrincipal from "../components/juridico/JuridicoPrincipal"; // 10/03/2024 as 11:25h
import Ml18PontoEletronicoPrincipalMonitoramento from "../components/ml18_frq_pontoeletronico/PonEletronicoPrincipalMonitoramento"; // 10/03/2024 as 11:25h
import JbSambaibaPreventivaOpcoes from "../components/sambaiba/JbManPreventivaOpcoes"; /// parametrização Sambaiba 06-07/2024 as 16:12hs
import JbSambaibaCorretivaOpcoes from "../components/sambaiba/JbManCorretivaOpcoes"; /// parametrização Sambaiba 06-07/2024 as 16:12hs
import JbManTacografoOpcoes from "../components/sambaiba/JbManTacografoOpcoes"; /// parametrização Sambaiba 06-07/2024 as 16:12hs
import JbSupSolicitacao from "../components/sambaiba/JbSupSolicitacaoOpcoes"; /// parametrização Sambaiba 06-07/2024 as 16:12hs
import JuridicoPrincipalAuditoria from "../components/juridico/JuridicoPrincipalAuditoria"; // 10/03/2024 as 11:25h
import CF7MenuPrincipal from "../components/sambaiba/CF7MenuPrincipal"; /// parametrização Sambaiba 06-07/2024 as 16:12hs
import CF7MenuConsultaPrincipal from "../components/sambaiba/CF7MenuConsultaPrincipal"; /// parametrização Sambaiba 06-07/2024 as 16:12hs
import TranppassBIAdministracaoPrincipal from "../components/transppass/TranppassBIAdministracaoPrincipal"; /// parametrização Sambaiba 06-07/2024 as 16:12hs
import JbSupMaterialTestePrincipal from "../components/sambaiba/JbSupMaterialTestePrincipal"; /// parametrização Sambaiba 06-07/2024 as 16:12hs
import SbLavadorPrincipal from "../components/sambaiba/SbLavadorPrincipal"; /// parametrização Sambaiba 06-07/2024 as 16:12hs
import SacAgendamentoPrincipal from "../components/sac_agendamento/SacAgendamentoPrincipal"; /// parametrização Sambaiba 06-07/2024 as 16:12hs
import Ml18ClientePrincipal from "../components/ml18/Ml18ClientePrincipal"; /// parametrização Sambaiba 06-07/2024 as 16:12hs
import FolImportacaoPrincipal from "../components/folhapagamento/FolImportacaoPrincipal"; /// folha de pagamento importação de recibos    10/12/2024 15:16h
import FolImportacaoFuncionarioPrincipal from "../components/folhapagamento/FolImportacaoFuncionarioPrincipal"; /// folha de pagamento importação de recibos    10/12/2024 15:16h
import SacChamadoPrincipal from "../components/sac_chamado/SacChamadoPrincipal"; /// folha de pagamento importação de recibos    10/12/2024 15:16h
import JuridicoProcessoPrincipal from "../components/juridico/JuridicoProcessoPrincipal"; /// folha de pagamento importação de recibos    10/12/2024 15:16h

import { userKey } from "@/global";

Vue.use(VueRouter);

const routes = [
  {
    name: "home",
    path: "/",
    component: Home,
  },

  {
    // implantação 23/05/2025
    name: "138",
    path: "/globus/treinamento",
    component: GlobusConvocacaoPrincipal,
  },

  //////////////////// criando o facilitador de consumir os dados via API     URL gerada: https://api-publica.datajud.cnj.jus.br/api_publica_trt2/_search
  ////  C6BANK PJ E PF SALDO DEVEDOR , A VIRADA
  {
    // implantação 15/04/2025
    name: "69",
    path: "/juridico/processo",
    component: JuridicoProcessoPrincipal,
  },

  //////////////////// agendamento com hora marcada operadores deptos  - ViaSudeste Thiago / Alex
  {
    // implantação 23/09/2024
    name: "306",
    path: "/sac/chamado/ticket",
    component: SacChamadoPrincipal,
  },

  //////////////////// agendamento com hora marcada operadores deptos  - ViaSudeste Thiago / Alex
  {
    // implantação 23/09/2024
    name: "304",
    path: "/folha/importacao/funcionario",
    component: FolImportacaoFuncionarioPrincipal,
  },

  //////////////////// agendamento com hora marcada operadores deptos  - ViaSudeste Thiago / Alex
  {
    // implantação 23/09/2024
    name: "303",
    path: "/folha/importacao",
    component: FolImportacaoPrincipal,
  },

  //////////////////// agendamento com hora marcada operadores deptos  - ViaSudeste Thiago / Alex
  {
    // implantação 23/09/2024
    name: "298",
    path: "/ml18/cliente",
    component: Ml18ClientePrincipal,
  },

  //////////////////// agendamento com hora marcada operadores deptos  - ViaSudeste Thiago / Alex
  {
    // implantação 23/09/2024
    name: "294",
    path: "/sac/agendamento",
    component: SacAgendamentoPrincipal,
  },

  //////////////////// integração sambaiba x jb
  {
    // implantação 06/07/2024
    name: "293",
    path: "/sambaiba/manutencao/lavador",
    component: SbLavadorPrincipal,
  },

  //////////////////// integração sambaiba x jb
  {
    // implantação 06/07/2024
    name: "291",
    path: "/sambaiba/suprimentos/materialteste",
    component: JbSupMaterialTestePrincipal,
  },

  //////////////////// integração sambaiba x jb
  {
    // implantação 06/07/2024
    name: "290",
    path: "/sambaiba/cf7/consulta",
    component: CF7MenuConsultaPrincipal,
  },
  //////////////////// integração sambaiba x jb
  {
    // implantação 06/07/2024
    name: "289",
    path: "/transppass/administracao/dashboard",
    component: TranppassBIAdministracaoPrincipal,
  },

  //////////////////// integração sambaiba x jb
  {
    // implantação 06/07/2024
    name: "88",
    path: "/sambaiba/CF7/magazine",
    component: CF7MenuPrincipal,
  },

  //////////////////// integração sambaiba x jb
  {
    // implantação 06/07/2024
    name: "81",
    path: "/juridico/auditoria",
    component: JuridicoPrincipalAuditoria,
  },

  //////////////////// integração sambaiba x jb
  {
    // implantação 06/07/2024
    name: "46",
    path: "/juridico/auditoria",
    component: JuridicoPrincipalAuditoria,
  },

  //////////////////// integração sambaiba x jb
  {
    // implantação 06/07/2024
    name: "62",
    path: "/sambaiba/suprimentos/solitacao",
    component: JbSupSolicitacao,
  },

  //////////////////// integração sambaiba x jb
  {
    // implantação 06/07/2024
    name: "66",
    path: "/sambaiba/tacografo",
    component: JbManTacografoOpcoes,
  },

  {
    // implantação 06/07/2024
    name: "64",
    path: "/sambaiba/corretiva",
    component: JbSambaibaCorretivaOpcoes,
  },

  //////////////////// integração sambaiba x jb
  {
    // implantação 06/07/2024
    name: "63",
    path: "/sambaiba/preventiva",
    component: JbSambaibaPreventivaOpcoes,
  },

  {
    // implantação 01/06/2024
    name: "45",
    path: "/pontoeletronico/monitoramento",
    component: Ml18PontoEletronicoPrincipalMonitoramento,
  },

  {
    // implantação 17/04/2024
    name: "43",
    path: "/pneu/juridico",
    component: JuridicoPrincipal,
  },

  {
    // implantação 10/04/2024
    name: "42",
    path: "/pneu/lancamentos",
    component: PneuPrincipalLançamentos,
  },

  {
    // implantação 10/04/2024
    name: "41",
    path: "/pneu",
    component: PneuPrincipal,
  },

  {
    // implantação 08/04/2024
    name: "129",
    path: "/frota",
    component: FrotaPrincipal,
  },

  // PADRÃO ADOTANDO COM BASE NO MENU DO ERP O ID_MENU SERÁ O CAMPO ATRIBUIDO COMO PERMISSÃO DE ACESSO AOS USUÁRIOS
  {
    // implantação 05/09/2023 as 16:41 - monitoramento telemetria kontrow
    name: "25",
    path: "/plantao",
    component: PlantaoMenu,
  },

  {
    // implantação 05/09/2023 as 16:41 - monitoramento telemetria kontrow
    name: "184",
    path: "/abastecimento",
    component: AbastecimentoPrincipal,
  },

  {
    // implantação 05/09/2023 as 16:41 - monitoramento telemetria kontrow
    name: "24",
    path: "/requisicao",
    component: RequisicaoPrincipal,
  },

  {
    // implantação 05/12/2023 as 15:07 - indicadores de utilização dos aplicativos
    name: "22",
    path: "/informatica",
    component: InformaticaPrincipal,
  },

  {
    // implantação 05/09/2023 as 16:41 - monitoramento telemetria kontrow
    name: "21",
    path: "/kontrow",
    component: KontrowPrincipal,
  },

  {
    // implantação 29/08/2023 as 21:49h -  cadastro de sinistro
    name: "19",
    path: "/sinistro",
    component: SinistroPrincipal,
  },

  {
    // implantação 12/08/2023 as 19:13h -  cadastro de informativos app portal do colaborador
    name: "17",
    path: "/sac_informativo",
    component: InfoPrincipal,
  },

  {
    // implantação 11/07/2023 as 21:01h -  escala modelo padrão integração com app de fiscal e ponto eletronico
    name: "16",
    path: "/flp_cadastro",
    component: FuncionarioPrincipal,
  },

  {
    // implantação 11/07/2023 as 21:01h -  escala modelo padrão integração com app de fiscal e ponto eletronico
    name: "103",
    path: "/pla_escala",
    component: EscalaModeloMenu,
  },

  {
    name: "87",
    path: "/admin",
    component: AdminPages,
    meta: { requiresAdmin: true },
  },
  {
    name: "180",
    path: "/oficina/preventiva",
    component: ManPreventivaLancamento,
  },

  {
    name: "183",
    path: "/manutencao/rfi",
    component: ManutencaoRfiLancamento,
  },

  {
    name: "7",
    path: "/manutencao/lavador",
    component: ManutencaoLavadorPrincipal,
  },

  {
    name: "8",
    path: "/sac/solicitacao",
    component: SacPrincipal,
  },

  {
    name: "185",
    path: "/trafego/monitoramento",
    component: TrafegoMonitoramento,
  },

  {
    name: "11",
    path: "/trafego/dashboardoperacional",
    component: DashboardOperacional,
  },

  {
    // implantação 29/09/2022
    name: "10",
    path: "/operacao_frota/frota",
    component: SolturaDeFrotaPrincipal,
  },

  {
    // implantação 12/10/2022 18:15
    name: "12",
    path: "/pla_linha",
    component: LinhaPrincipal,
  },

  {
    // implantação 24/12/2022 18:24
    name: "14",
    path: "/pontoeletronico",
    component: PontoEletronicoPrincipal,
  },

  {
    // implantação 24/12/2022 18:24
    name: "44",
    path: "/ml18pontoeletronico",
    component: PonEletronicoPrincipal,
  },

  {
    // implantação 26/12/2022 16:14
    name: "179",
    path: "/manutencao/corretiva",
    component: CorretivaPrincipal,
  },

  {
    name: "articlesByCategory",
    path: "/categories/:id/articles",
    component: ArticlesByCategory,
  },

  {
    name: "articleById",
    path: "/articles/:id",
    component: ArticleById,
  },

  {
    name: "auth",
    path: "/auth",
    component: Auth,
  },
];
const router = new VueRouter({
  mode: "history",
  routes,
});

router.beforeEach((to, from, next) => {
  const json = localStorage.getItem(userKey);

  if (to.matched.some((record) => record.meta.requiresAdmin)) {
    const user = JSON.parse(json);
    user && user.admin ? next() : next({ path: "/" });
  } else {
    next();
  }
});

export default router;
